import { render, staticRenderFns } from "./DashboardLiveStatisticsMultipleMatches.vue?vue&type=template&id=28fc76a2&scoped=true"
import script from "./DashboardLiveStatisticsMultipleMatches.vue?vue&type=script&lang=js"
export * from "./DashboardLiveStatisticsMultipleMatches.vue?vue&type=script&lang=js"
import style0 from "./DashboardLiveStatisticsMultipleMatches.vue?vue&type=style&index=0&id=28fc76a2&prod&lang=scss"
import style1 from "./DashboardLiveStatisticsMultipleMatches.vue?vue&type=style&index=1&id=28fc76a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fc76a2",
  null
  
)

export default component.exports